import { InterruptionCreateFormValues, InterruptionType } from '../../types';
import useCreateInterruptionSubmit from '../useCreateInterruptionSubmit';

const useCreateTaskStatusPingInterruptionSubmit = () => {
  const { createInterruptionFromValues } = useCreateInterruptionSubmit();

  const createTaskStatusPing = async (values: InterruptionCreateFormValues) =>
    createInterruptionFromValues(values, InterruptionType.TaskStatusPing);

  return {
    createTaskStatusPing,
  };
};

export default useCreateTaskStatusPingInterruptionSubmit;
